import styled from '@emotion/styled';
import { settingsTheme as t } from '../../theme';

export interface TabOption<T extends string> {
  value: T;
  label: string;
  count: number;
}

interface SegmentedTabsProps<T extends string> {
  options: TabOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

const Track = styled.div({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 4,
  padding: 4,
  borderRadius: 11,
  background: t.color.segmentTrack,
});

const Tab = styled.button<{ active: boolean }>(({ active }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 7,
  padding: '8px 16px',
  border: 'none',
  borderRadius: t.radius.xs,
  cursor: 'pointer',
  fontFamily: t.font,
  fontSize: 13.5,
  fontWeight: active ? 600 : 500,
  color: active ? t.color.segmentActiveText : t.color.text,
  background: active ? t.color.surface : 'transparent',
  boxShadow: active ? '0 1px 2px rgba(16, 24, 40, 0.12)' : 'none',
  transition: 'background 0.15s ease, color 0.15s ease',
}));

const Count = styled.span({
  fontFamily: t.font,
  fontSize: 11.5,
  padding: '1px 8px',
  borderRadius: 10,
  background: '#e2e6ea',
  color: '#6b7178',
});

/**
 * Molécula: control segmentado con conteo por opción (Todos / Internos / ...).
 * Genérico sobre el tipo del valor para reutilizarse con cualquier enum.
 */
function SegmentedTabs<T extends string>({ options, value, onChange }: SegmentedTabsProps<T>) {
  return (
    <Track>
      {options.map(option => (
        <Tab key={option.value} type="button" active={option.value === value} onClick={() => onChange(option.value)}>
          {option.label}
          <Count>{option.count}</Count>
        </Tab>
      ))}
    </Track>
  );
}

export default SegmentedTabs;
